import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { getAllAccesses } from '../../api/authenticateAPIs';

import '../../css/pages/manage_teams.css';

// Mapovanie názvu prístupu z BE na prekladový kľúč (fallback = surový názov z BE)
const ACCESS_LABEL_KEYS = {
    DataAccess: 'accessData',
    DocumentsAccess: 'accessDocuments',
    ChatAccess: 'accessChat',
};

export default function AccessMultiselect({ selectedValues, onChange }) {

    const [t] = useTranslation('global');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [accessOptions, setAccessOptions] = useState([]);
    const dropdownRef = useRef(null);

    // Reálne prístupy z BE (id + name) — nie z tabConfig, aby id sedeli s DB
    useEffect(() => {
        getAllAccesses()
            .then((data) => {
                setAccessOptions(
                    (data || []).map((a) => ({
                        value: a.id,
                        label: ACCESS_LABEL_KEYS[a.name] || a.name,
                    }))
                );
            })
            .catch((err) => console.log(err));
    }, []);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleSelect = (value) => {
        if (selectedValues.includes(value)) {
            onChange({ target: { value: selectedValues.filter((v) => v !== value) } });
        } else {
            onChange({ target: { value: [...selectedValues, value] } });
        }
    };

    const handleDelete = (value) => {
        onChange({ target: { value: selectedValues.filter((v) => v !== value) } });
    };

    return (
        <div className="mill-multiselect" ref={dropdownRef}>
            <label>{t('accessPermissions')}</label>
            <div className="multiselect-line" onClick={toggleDropdown}>
                <div className="selected-values">
                    {selectedValues.map((value) => {
                        const option = accessOptions.find((o) => o.value === value);
                        return (
                            <span key={value} className="selected-chip">
                                {option ? t(option.label) : value}
                                <button className="delete-chip" onClick={(e) => { e.stopPropagation(); handleDelete(value); }}>
                                    &times;
                                </button>
                            </span>
                        );
                    })}
                </div>
                <span className="dropdown-icon material-symbols-outlined">
                    {isDropdownOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                </span>
            </div>
            {isDropdownOpen && (
                <div className="dropdown-menu">
                    <ul className="dropdown-list">
                        {accessOptions.map((option) => (
                            <li
                                key={option.value}
                                className={`dropdown-item ${selectedValues.includes(option.value) ? "selected" : ""}`}
                                onClick={() => handleSelect(option.value)}
                            >
                                {t(option.label)}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
